/**
 * useFollowers Hook (Web)
 * Thin wrapper around shared useFollowers
 */

import { useAuth } from '@contexts/AuthContext';
import { createHttpClient } from '@parlay-picker/shared/api/httpClient';
import {
  type UseFollowersResult,
  useFollowers as useFollowersShared,
} from '@parlay-picker/shared/hooks';
import { useMemo } from 'react';
import { API_BASE_URL } from '../config/api';

export type { UseFollowersResult };

export function useFollowers(displayName: string | undefined): UseFollowersResult {
  const { authFetch } = useAuth();

  const httpClient = useMemo(
    () => createHttpClient({ authFetch, baseUrl: API_BASE_URL }),
    [authFetch],
  );

  return useFollowersShared({ httpClient, displayName });
}
